var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.value !== null
      ? _c("div", { staticClass: "dinlineb" }, [
          _c(
            "span",
            { class: ["avatar mr-1 pt-2", _vm.classNames] },
            [
              _c("icon", {
                staticStyle: { "line-height": "initial" },
                attrs: { icon: _vm.icon }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("span", { staticClass: "avatar-name" }, [
            _vm._v(_vm._s(_vm.$filters.capitalize(_vm.value)))
          ])
        ])
      : _c("span", [_vm._v("\n        " + _vm._s(_vm.placeholder) + "\n    ")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }